var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('banner'),_c('content-role'),_c('content-work'),_c('case-area')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }